// ── Mobile menu ───────────────────────────────────────────
const hamburger  = document.getElementById('hamburger');
const mobileMenu = document.getElementById('mobileMenu');
const menuClose  = document.getElementById('menuClose');

hamburger && hamburger.addEventListener('click', () => {
  mobileMenu.classList.add('open');
  document.body.style.overflow = 'hidden';
});
menuClose && menuClose.addEventListener('click', () => {
  mobileMenu.classList.remove('open');
  document.body.style.overflow = '';
});
document.querySelectorAll('.mobile-link').forEach(l => l.addEventListener('click', () => {
  mobileMenu.classList.remove('open');
  document.body.style.overflow = '';
}));

// ── Nav scroll elevation ──────────────────────────────────
const nav = document.getElementById('nav');
function updateNav() {
  if (!nav) return;
  nav.classList.toggle('nav-solid', window.scrollY > 40);
}
updateNav();

// ── Scroll reveal ─────────────────────────────────────────
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('revealed');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

// ── Statement — staggered word reveal ─────────────────────
const statementText = document.querySelector('.statement-text');
if (statementText) {
  const statementObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        statementObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.35 });
  statementObserver.observe(statementText);
}

// ── Subtle parallax ───────────────────────────────────────
const parallaxEls = Array.from(document.querySelectorAll('[data-parallax]'));
function updateParallax() {
  const vh = window.innerHeight;
  parallaxEls.forEach(el => {
    const rect = el.getBoundingClientRect();
    if (rect.bottom < -100 || rect.top > vh + 100) return;   // skip offscreen
    const speed = parseFloat(el.dataset.parallax) || 0.12;
    const progress = (rect.top + rect.height / 2 - vh / 2) / vh;  // -1 .. 1
    const y = -progress * speed * 100;
    el.style.transform = `translate3d(0, ${y.toFixed(1)}px, 0) scale(1.12)`;
  });
}

// ── rAF-throttled scroll loop ─────────────────────────────
let ticking = false;
function onScroll() {
  if (ticking) return;
  ticking = true;
  requestAnimationFrame(() => {
    updateNav();
    updateParallax();
    ticking = false;
  });
}
window.addEventListener('scroll', onScroll, { passive: true });
window.addEventListener('resize', updateParallax, { passive: true });
updateParallax();

// ── Spotted gallery arrows ────────────────────────────────
const spottedTrack = document.getElementById('spottedTrack');
if (spottedTrack) {
  const spottedStep = () => {
    const card = spottedTrack.querySelector('.spotted-card');
    return card ? card.getBoundingClientRect().width + 16 : 320;
  };
  document.getElementById('spottedPrev').addEventListener('click', () =>
    spottedTrack.scrollBy({ left: -spottedStep(), behavior: 'smooth' }));
  document.getElementById('spottedNext').addEventListener('click', () =>
    spottedTrack.scrollBy({ left: spottedStep(), behavior: 'smooth' }));
}

// ── Email form ────────────────────────────────────────────
const clubForm = document.getElementById('clubForm');
if (clubForm) {
  clubForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const input = clubForm.querySelector('.club-input');
    const btn   = clubForm.querySelector('.btn');
    if (!input.value || !input.validity.valid) { input.focus(); return; }
    btn.textContent = "You're in. ✓";
    btn.style.background = '#2D6A4F';
    btn.style.color = '#F4EFE6';
    btn.style.cursor = 'default';
    input.value = '';
    input.disabled = true;
    btn.disabled = true;
  });
}

/* opt-in video: unfolds inline, nothing loads until asked for */
(function () {
  function init() {
    var wraps = document.querySelectorAll('.mk-vwrap');
    if (!wraps.length) return;

    Array.prototype.forEach.call(wraps, function (wrap) {
      var btn = wrap.querySelector('[data-vtoggle]');
      var vid = wrap.querySelector('.mk-vplayer');
      if (!btn || !vid) return;

      btn.addEventListener('click', function () {
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');

        if (open) {
          var p = vid.play();
          if (p && p.catch) p.catch(function () {}); /* native control still works */
          /* keep the player in view once it has finished unfolding */
          setTimeout(function () {
            var r = wrap.getBoundingClientRect();
            if (r.bottom > window.innerHeight) {
              wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }, 520);
        } else {
          vid.pause();
        }
      });

      vid.addEventListener('ended', function () {
        wrap.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Doors have no hover on touch, so the one you have scrolled to opens itself. */
(function () {
  var doors = document.querySelectorAll('.mk-door');
  if (!doors.length || !('IntersectionObserver' in window)) return;
  var mq = window.matchMedia('(max-width: 860px)');
  var io = null;

  function start() {
    if (io) return;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('is-live', e.isIntersecting);
      });
    }, { rootMargin: '-42% 0px -42% 0px', threshold: 0 });  /* middle band of the screen */
    Array.prototype.forEach.call(doors, function (d) { io.observe(d); });
  }
  function stop() {
    if (!io) return;
    io.disconnect(); io = null;
    Array.prototype.forEach.call(doors, function (d) { d.classList.remove('is-live'); });
  }
  function sync() { mq.matches ? start() : stop(); }

  sync();
  if (mq.addEventListener) mq.addEventListener('change', sync);
  else if (mq.addListener) mq.addListener(sync);
})();

/* The in-hand clip: 1.8MB that only downloads if you actually scroll to it. */
(function () {
  function init() {
    var vid = document.querySelector('.mk-clip-vid');
    if (!vid || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var p = vid.play();               /* preload="none" means play() is what fetches it */
          if (p && p.catch) p.catch(function () {});
        } else if (!vid.paused) {
          vid.pause();                      /* offscreen loops burn battery for nothing */
        }
      });
    }, { threshold: 0.25 });
    io.observe(vid);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ============================================================
   CART DRAWER  (cart-aware, no page reloads)
   ============================================================ */
(function () {
  function init() {
  var drawer = document.getElementById('cartDrawer');
  var overlay = document.getElementById('cartDrawerOverlay');
  if (!drawer || !overlay) return;

  var cross = [];
  try { cross = JSON.parse(document.getElementById('cd-crosssell').textContent); } catch (e) {}
  var COMPARE = {};
  try { COMPARE = JSON.parse(document.getElementById('cd-compare').textContent); } catch (e) {}
  function compareOf(item) { var c = COMPARE[item.variant_id] || 0; return c > item.price ? c : 0; }

  var lastAddedId = null;   // variant id of the most recent add, for the highlight
  var dealActive = false;   // Buy 2 Get 1 live -> show each line at the further-discounted per-tin
  var dealPer = 0;          // effective per-tin when the deal is live
  var currentCart = null;   // last rendered cart, for the quick-edit popup

  var elReward = document.getElementById('cdReward');
  var elItems = document.getElementById('cdItems');
  var elCross = document.getElementById('cdCross');
  var elExpress = document.getElementById('cdExpress');
  var elFoot = document.getElementById('cdFoot');
  var elNote = document.getElementById('cdFootNote');

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function escB(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }

  // colorway -> tin photo, for real image swatches
  var SWATCH_IMG = {};
  try { SWATCH_IMG = JSON.parse(document.getElementById('cd-swatch-imgs').textContent); } catch (e) {}
  // Lid patterns (Oct 22 2026): a product with p.patterns lists every colour x pattern variant (title = colour, pat = pattern).
  // Everywhere that shows colour dots shows one per colour; a chip row picks the pattern; (colour, pattern) -> variant.
  function colorsOf(p, pat) { var seen = {}, out = []; (p.variants || []).forEach(function (v) { if (!v.available) return; if (seen[v.title]) { if (pat && v.pat === pat) seen[v.title].id = v.id; return; } var c = { id: v.id, title: v.title, available: true, pat: v.pat }; seen[v.title] = c; out.push(c); }); return out; }
  function variantFor(p, color, pat) { var best = null, vs = p.variants || []; for (var i = 0; i < vs.length; i++) { var v = vs[i]; if (!v.available || v.title !== color) continue; if (!p.patterns || !pat || v.pat === pat) return v; if (!best) best = v; } return best; }
  // Pattern dots need assets/marlo-patterns.js (window.marloPatDot); product pages with patterns already load it, the cart
  // drawer pulls it in the first time a pattern product shows up. Until then the dots render as plain circles.
  var patAssetState = 0;
  function ensurePatAsset(then) {
    if (window.marloPatDot) { if (then) then(); return; }
    var src = document.getElementById('cd-patterns-src'); if (!src || patAssetState === 2) return;
    if (patAssetState === 1) { if (then) document.addEventListener('marlo:patterns', then, { once: true }); return; }
    patAssetState = 1; var sc = document.createElement('script'); sc.src = src.textContent.trim();
    sc.onload = function () { document.dispatchEvent(new Event('marlo:patterns')); if (then) then(); }; sc.onerror = function () { patAssetState = 2; };
    document.head.appendChild(sc);
  }
  function patDot(pn, color) { return window.marloPatDot ? window.marloPatDot(pn, color) : '<svg viewBox="0 0 10 10" aria-hidden="true"><circle cx="5" cy="5" r="4.6" fill="#E9E2D2"/></svg>'; }
  function patRow(p, color, pat, attr) { if (!p.patterns) return ''; return '<div class="pdp-bundle-patrow">' + p.patterns.map(function (pn) { var ok = !!variantFor(p, color, pn); return '<button type="button" class="pdp-bundle-pat' + (pn === pat ? ' is-sel' : '') + '" ' + (attr || 'data-pat') + '="' + escB(pn) + '" title="' + escB(pn) + '"' + (ok ? '' : ' disabled') + '>' + patDot(pn, color) + escB(pn) + '</button>'; }).join('') + '</div>'; }
  function variantById(p, vid) { var vs = p.variants || []; for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === String(vid)) return vs[i]; return null; }
  function swatchDots(variants) {
    var seen = {}; variants = variants.filter(function (v) { if (seen[v.title]) return false; seen[v.title] = true; return true; });   // one dot per colour
    return variants.map(function (v, i) {
      var url = SWATCH_IMG[v.title] || '';
      var inner = url ? '<img src="' + url + '" alt="' + v.title + '">' : '';
      return '<button type="button" class="cd-sw' + (i === 0 ? ' is-sel' : '') + '" data-vid="' + v.id
        + '" data-name="' + v.title + '" title="' + v.title + '" aria-label="' + v.title + '">' + inner + '</button>';
    }).join('');
  }

  function openDrawer() {
    if (!window.marloPatDot && cross.some(function (x) { return x.patterns; })) ensurePatAsset(function () { if (bState) renderBuilder(); });
    drawer.hidden = false; overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { drawer.classList.add('is-open'); overlay.classList.add('is-open'); fitExpress(); });
  }
  // Express pay row: Shopify's wallet buttons live in a closed shadow root and stack vertically when their
  // box is under 430px wide (four wallets on an iPhone). The host is laid out at 460px (styles.css) and
  // scaled to the footer's real width here, so the wallets stay in ONE row at every phone size.
  function fitExpress() {
    if (!elExpress || elExpress.hidden) return;
    var w = elExpress.clientWidth;
    if (!w) { w = (drawer.getBoundingClientRect().width || Math.min(440, window.innerWidth)) - (window.innerWidth <= 480 ? 32 : 45); }
    elExpress.style.setProperty('--cd-xscale', Math.min(1, w / 460).toFixed(4));
  }
  window.addEventListener('resize', fitExpress);
  function closeDrawer() {
    drawer.classList.remove('is-open'); overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; overlay.hidden = true; }, 320);
  }

  // ---- unified cart-aware deal message (same brain everywhere) ----
  // Link under the banner. It does exactly what the "Pick your FREE 3rd tin" button does:
  // opens the pick-a-tin popup right here in the cart, never sends the shopper off to another page.
  function grabLink(label) {
    return '<p class="cd-r-mix"><button type="button" data-cd-pick style="background:none;border:0;padding:0;margin:0;font:inherit;font-weight:700;color:var(--brass-light);text-decoration:underline;text-underline-offset:2px;cursor:pointer;">' + label + ' &rarr;</button></p>';
  }
  // Slim progress strip at the TOP of the cart (Oct 19 2026 cart v2). It says where the shopper
  // stands on Buy 2 Get 1 in one line, with three dots, and is tappable (opens the 3-pack builder).
  // The gold box with its big button moved BELOW the items so the orange Checkout is the one big
  // button on screen. Nothing here hardcodes a dollar amount.
  function topOffer(cart) {
    var n = cart.item_count;
    elReward.classList.add('cd-reward--strip');
    var dots = '';
    for (var i = 0; i < 3; i++) dots += '<i class="cd-dot' + (i < Math.min(n, 3) ? ' is-on' : '') + '"></i>';
    if (n >= 3) {
      return '<div class="cd-strip cd-strip--won"><span class="cd-strip-dots">' + dots + '</span>'
        + '<span class="cd-strip-txt">Free tin and free shipping <b>locked in</b></span>'
        + '<span class="cd-strip-check" aria-hidden="true">&#10003;</span></div>';
    }
    // Oct 19 (Jared): ONE offer card, at the top, and nothing between the items and the footer, so the
    // only button-shaped things in the cart are Checkout and the wallets. The whole card is the tap target:
    // regular tins open the 3-pack builder, word and custom tins go back to their studio page.
    var base = baseProductFromCart(cart);
    var st = base ? null : studioFromCart(cart);
    var thumb = base ? base.p.img : (st ? st.img : '');
    var head = n === 2 ? 'Your 3rd tin is <b>FREE</b>' : 'Add 1 more, your 3rd tin is <b>FREE</b>';
    var sub = st
      ? (st.word ? 'Another ' + st.title + ', any word and any color.' : 'Design another, any words and any colors.')
      : (base ? 'Another <strong>' + base.p.title + '</strong> in a new color, or any other design.' : 'Any design, any color. It is on us.');
    var go = st ? (st.word ? 'Pick a word' : 'Design it') : 'Pick';
    var inner = (thumb ? '<img class="cd-strip-thumb" src="' + thumb + '" alt="">' : '')
      + '<span class="cd-strip-body"><span class="cd-strip-dots">' + dots + '</span>'
      + '<span class="cd-strip-h">' + head + '</span>'
      + '<span class="cd-strip-sub">' + sub + '</span></span>'
      + '<span class="cd-strip-go">' + go + ' <span class="arw">&rarr;</span></span>';
    if (st) return '<a class="cd-strip cd-strip--card" href="' + st.url + '">' + inner + '</a>';
    return '<button type="button" class="cd-strip cd-strip--card" data-cd-pick>' + inner + '</button>';
  }
  // At exactly 3 tins the next step is one quiet line under the items: what a 4th costs on top of the
  // 3-pack. "4 tins for $49.95" is a flat $29.85 off, so the 4th adds (its price + the 3rd that is no
  // longer free - 29.85). $19.95 tins: $10.05. Shown only when that comes out as a real deal (under
  // 60% of a tin), so $24.95 studio tins never see it.
  function fourthLine(cart) {
    return '';   // Oct 21 (Jared): the 4th-tin upsell at 3 tins is off, it read as spammy. Code kept below for a holiday return.
    var cheapest = Math.min.apply(null, cart.items.map(function (it) { return it.original_price || it.price; }));
    var extra = cheapest * 2 - 2985;
    if (!(extra > 0 && extra < cheapest * 0.6)) return '';
    var url4 = ((cart.items[0] && cart.items[0].url) || '/collections/all').split('?')[0];
    return '<a href="' + url4 + '" class="cd-fourth"><span class="cd-fourth-h">Add a 4th for <b>' + money(extra) + '</b></span>'
      + '<span class="cd-fourth-sub">Make it a foursome. Four tins for ' + money(cheapest * 4 - 2985) + '.</span>'
      + '<span class="cd-fourth-go">Pick your 4th <span class="arw">&rarr;</span></span></a>';
  }
  function dealMsg(count) {
    if (count >= 3) {
      return '<p class="cd-r-msg cd-r-won">Your free tin and free shipping are locked in. Add more anytime.</p>'
        + '<div class="cd-r-track"><div class="cd-r-fill" style="width:100%"></div></div>';
    }
    if (count === 2) {
      return '<p class="cd-r-msg cd-r-won">Unlocked. Your 3rd tin is FREE. Any design, any color, it is on us.</p>'
        + '<div class="cd-r-track"><div class="cd-r-fill" style="width:100%"></div></div>' + grabLink('Grab your free tin here');
    }
    return '<p class="cd-r-msg">Add <strong data-cd-complete role="button" tabindex="0" style="text-decoration:underline;text-underline-offset:2px;cursor:pointer;">1 more</strong> to unlock your free tin. Your 3rd is on us.</p>'
      + '<div class="cd-r-track"><div class="cd-r-fill" style="width:50%"></div></div>' + grabLink('Pick your next tin here');
  }

  function itemHTML(item) {
    // Custom tins attach a rendered preview of the buyer's own design; show that instead of the product photo.
    var previewUrl = (item.properties && item.properties._Preview) ? item.properties._Preview : '';
    var thumb = previewUrl || item.image;
    var img = thumb ? '<img src="' + thumb + '" alt="">' : '<span></span>';
    // small color swatch next to the name so the chosen color is clear (product photo stays the thumbnail)
    var vswatch = SWATCH_IMG[item.variant_title] || '';
    var variant = (item.variant_title && !/default/i.test(item.variant_title))
      ? '<p class="cd-i-var">' + (vswatch ? '<img class="cd-i-swatch" src="' + vswatch + '" alt="">' : '') + item.variant_title + '</p>'
      : '';
    var added = item.variant_id === lastAddedId;
    var addedCls = added ? ' cd-item--added' : '';
    var addedTag = added ? '<span class="cd-i-just">Just added</span>' : '';
    // Show the real allocation: the free (cheapest) tin reads FREE and stands out;
    // every other line shows its own price, with the compare-at markdown struck through.
    var cmp = compareOf(item);
    var priceHTML;
    var isFreeLine = dealActive && item.final_line_price === 0;
    if (isFreeLine) {
      var wasFree = (cmp || item.price) * item.quantity;
      priceHTML = '<span class="cd-i-price cd-i-price--free"><span class="cd-i-free">FREE</span><s class="cd-i-was">' + money(wasFree) + '</s></span>';
    } else if (item.final_line_price < item.original_line_price) {
      // a line with more than one tin where one of them is the free tin
      priceHTML = '<span class="cd-i-price cd-i-price--sale"><s class="cd-i-was">' + money(item.original_line_price) + '</s><span class="cd-i-now">' + money(item.final_line_price) + '</span></span>';
    } else if (cmp) {
      priceHTML = '<span class="cd-i-price cd-i-price--sale"><s class="cd-i-was">' + money(cmp * item.quantity) + '</s><span class="cd-i-now">' + money(item.final_line_price) + '</span></span>';
    } else {
      priceHTML = '<span class="cd-i-price">' + money(item.final_line_price) + '</span>';
    }
    return '<div class="cd-item' + addedCls + '" data-key="' + item.key + '">' + img
      + '<div><p class="cd-i-title">' + item.product_title + '</p>' + variant + addedTag
      + '<div class="cd-qty"><button type="button" data-cd-dec aria-label="Decrease">&minus;</button><span>' + item.quantity + '</span><button type="button" data-cd-inc aria-label="Increase">+</button></div>'
      + ((item.properties && (item.properties.Artwork || item.properties._Preview || item.properties.Text)) ? '' : '<button type="button" class="cd-i-edit" data-cd-edit>' + ((productForItem(item) && productForItem(item).patterns) ? 'Edit color &amp; pattern' : 'Edit color') + '</button>') + '</div>'
      + '<div class="cd-i-right">' + priceHTML
      + '<button type="button" class="cd-i-remove" data-cd-remove>Remove</button></div></div>';
  }

  // The product the shopper already has, resolved to its full colorway list (needs 2+ colors to offer choices).
  function baseProductFromCart(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var p = productForItem(cart.items[i]);
      if (p) {
        var avail = (p.variants || []).filter(function (v) { return v.available; });
        if (avail.length >= 2) return { p: p, avail: avail };
      }
    }
    return null;
  }
  function usedVariants(cart, pid) {
    var used = {};
    cart.items.forEach(function (it) { if (it.product_id === pid) used[it.variant_id] = true; });
    return used;
  }
  // Word tins and Design Your Own tins are made in their own studio page (the word rides on the
  // line item), so they can't be added from a color picker here. Send the shopper back to the studio.
  function studioFromCart(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i], pr = it.properties || {};
      if (pr.Text || pr._Preview) {
        return { title: it.product_title, url: '/products/' + it.handle, img: pr._Preview || it.image, word: !!pr.Word };
      }
    }
    return null;
  }
  // Mixed cart (a regular tin plus a word or custom tin): the box offers the regular tin's colors,
  // so add a second way to make the next one a word or custom tin instead.
  function studioAltLink(cart) {
    var st = studioFromCart(cart);
    if (!st) return '';
    return '<a href="' + st.url + '" style="display:block;margin:.6rem 0 0;text-align:center;font-size:.82rem;font-weight:600;text-decoration:underline;text-underline-offset:3px;color:inherit;">'
      + (st.word ? 'Or pick another word instead' : 'Or design another instead') + ' &rarr;</a>';
  }
  function studioSetCTA(cart, st) {
    var need = 3 - cart.item_count;
    var heading = need >= 2
      ? 'Add 1 more. Your 3rd tin is <span class="cd-free">on us</span>'
      : 'Your 3rd tin is <span class="cd-free">FREE</span>';
    var sub = st.word
      ? 'Another <strong>' + st.title + '</strong>, any word and any color you like.'
      : 'Design another tin, any words and any colors you like.';
    var label = st.word ? (need >= 2 ? 'Pick another word' : 'Pick your free word') : (need >= 2 ? 'Design another' : 'Design your free tin');
    var thumb = st.img ? '<img class="cd-complete-thumb" src="' + st.img + '" alt="">' : '';
    return '<div class="cd-complete">'
      + '<div class="cd-complete-top">' + thumb
      + '<div class="cd-complete-txt"><p class="cd-complete-h">' + heading + '</p>'
      + '<p class="cd-complete-sub">' + sub + '</p></div></div>'
      + '<a href="' + st.url + '" class="btn cd-complete-btn">' + label + ' <span class="arw">&rarr;</span></a>'
      + '</div>';
  }
  // Primary offer: complete a set of 3 of the SAME tin in other colors, 3rd free.
  function completeSetCTA(cart) {
    if (cart.item_count >= 3) return '';
    var base = baseProductFromCart(cart);
    if (!base) { var st = studioFromCart(cart); return st ? studioSetCTA(cart, st) : ''; }
    var need = 3 - cart.item_count;
    var title = base.p.title;
    var thumb = base.p.img ? '<img class="cd-complete-thumb" src="' + base.p.img + '" alt="' + title + '">' : '';
    // Lead with the OFFER (not the same words as the top banner) and make it dead clear
    // this is the SAME tin in a different color, with the free one screaming.
    var heading, sub, label;
    if (need >= 2) {
      heading = 'Add 1 more. Your 3rd tin is <span class="cd-free">on us</span>';
      sub = 'Another <strong>' + title + '</strong> in a new color, or any other design.';
      label = 'Pick your next tin';
    } else {
      heading = 'Your 3rd tin is <span class="cd-free">FREE</span>';
      sub = 'Any design, any color. It is on us.';
      label = 'Pick your free tin';
    }
    return '<div class="cd-complete">'
      + '<div class="cd-complete-top">' + thumb
      + '<div class="cd-complete-txt"><p class="cd-complete-h">' + heading + '</p>'
      + '<p class="cd-complete-sub">' + sub + '</p></div></div>'
      + '<button type="button" class="btn cd-complete-btn" data-cd-complete>' + label + ' <span class="arw">&rarr;</span></button>'
      + studioAltLink(cart)
      + '</div>';
  }
  // Secondary offer: a different design, collapsed behind a toggle so it is not confusing by default.
  function otherDesignsHTML(cart) {
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var picks = cross.filter(function (p) { return !inCart[p.id]; }).slice(0, 3);
    if (!picks.length) return '';
    var isFree = cart.item_count === 2;
    var addLabel = isFree ? 'Add free' : 'Add';
    var cards = picks.map(function (p) {
      var avail = (p.variants || []).filter(function (v) { return v.available; });
      if (!avail.length) return '';
      var dots = swatchDots(avail);
      var firstName = avail[0].title;
      return '<div class="cd-x-card">'
        + '<a class="cd-x-media" href="/products/' + (p.handle || '') + '">' + (p.img ? '<img src="' + p.img + '" alt="">' : '<span></span>') + '</a>'
        + '<div class="cd-x-info"><p class="cd-x-title">' + p.title + '</p>'
        + '<p class="cd-x-price">' + (isFree ? '<span class="cd-x-free">FREE</span> <s>' + money(p.price) + '</s>' : money(p.price)) + '</p>'
        + '<div class="cd-sw-row">' + dots + '</div>'
        + '<p class="cd-x-picked">Color: <strong>' + firstName + '</strong></p>'
        + '<button type="button" class="cd-x-add" data-cd-add data-vid="' + avail[0].id + '">' + addLabel + '</button>'
        + '</div></div>';
    }).join('');
    return '<details class="cd-x-more"><summary class="cd-x-more-sum">Or add a different design</summary>'
      + '<div class="cd-x-more-body">'
      + '<p class="cd-x-subhead">' + (isFree ? 'Your 3rd tin is on us, or mix in a different design.' : 'A different tin. Tap Add to include one.') + '</p>'
      + cards
      + '<a class="cd-x-all" href="/collections/all">See all Editions and colors &rarr;</a>'
      + '</div></details>';
  }
  function crossHTML(cart) {
    // Below the items: the gold "pick your next tin" box while the set is open (its button is the
    // smaller, secondary one; Checkout in the footer is the big one), or the quiet 4th-tin line at 3.
    // otherDesignsHTML() is kept above in case the "different design" list is wanted back.
    // Below the items only the quiet 4th-tin line at exactly 3 tins. The offer card is the top strip.
    if (cart.item_count === 3) return fourthLine(cart);
    return '';
  }

  function render(cart) {
    currentCart = cart;
    Array.prototype.forEach.call(document.querySelectorAll('.js-cart-count'), function (el) { el.textContent = cart.item_count; });
    Array.prototype.forEach.call(document.querySelectorAll('.js-cart-badge'), function (el) { el.hidden = (cart.item_count === 0); });
    // keep any on-page deal line in sync (e.g., the product page offer)
    Array.prototype.forEach.call(document.querySelectorAll('.js-deal-line'), function (el) { el.innerHTML = onPageDeal(cart.item_count, el); });

    if (cart.item_count === 0) {
      elReward.innerHTML = '';
      elItems.innerHTML = '';
      elCross.innerHTML = '';
      if (elExpress) elExpress.hidden = true;
      if (elNote) elNote.hidden = true;
      elFoot.innerHTML = '<p class="cd-empty">Your cart is empty.</p><a href="' + '/collections/all" class="btn btn-brass" data-cd-close>Shop the Editions</a>';
      return;
    }
    dealActive = cart.total_discount > 0;
    dealPer = cart.item_count ? Math.round(cart.total_price / cart.item_count) : 0;

    elReward.innerHTML = topOffer(cart);
    elItems.innerHTML = cart.items.map(itemHTML).join('');
    // Express pay (Shop Pay / PayPal / Google Pay) lives in the pinned footer under Checkout now,
    // so it is on screen at every quantity. Show it only if the store rendered any.
    if (elExpress) elExpress.hidden = !elExpress.querySelector('.additional-checkout-buttons, [data-shopify], shop-pay-wallet-button, .shopify-payment-button');
    if (elNote) elNote.hidden = false;
    fitExpress();
    // "Was" = sum of compare-at prices (falls back to unit price when none set),
    // so the markdown shows at every quantity, plus any Buy 2 Get 1 saving.
    var wasTotal = 0;
    cart.items.forEach(function (i) { var c = compareOf(i); wasTotal += (c || i.price) * i.quantity; });
    var save = wasTotal - cart.total_price;
    var hasSave = save > 0;
    var n = cart.item_count;
    var cx = crossHTML(cart);
    elCross.innerHTML = cx;
    elCross.style.display = cx ? '' : 'none';   // no empty band under the items
    // Pinned footer = two value rows + the one big orange button + express pay + trust line.
    // Kept to TWO rows on purpose: on a real iPhone Shopify renders four wallets (Apple Pay too),
    // so every extra line here is a line of cart the shopper cannot see.
    // Row 1: "3 tins · $14.97 each" (deal live) and the was/now total.
    // Row 2: shipping (crossed-out $5 -> FREE, so nobody bails expecting a charge) and the You save chip.
    var lbl = n + (n === 1 ? ' tin' : ' tins')
      + (dealActive ? ' <span class="cd-sum-each">&middot; <b>' + money(dealPer) + '</b> each</span>' : '');
    var totalRow =
      '<div class="cd-sum-row cd-sum-total">'
      + '<span class="cd-sum-lbl">' + lbl + '</span>'
      + '<span class="cd-sum-amt">' + (hasSave ? '<s class="cd-was">' + money(wasTotal) + '</s>' : '') + '<span class="cd-now">' + money(cart.total_price) + '</span></span>'
      + '</div>';
    var shipRow =
      '<div class="cd-sum-row cd-sum-ship">'
      + '<span class="cd-sum-lbl"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 3h13v10H1z"/><path d="M14 6h4l3 3v4h-7z"/><circle cx="5.5" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>Shipping <s class="cd-was">' + money(500) + '</s><b class="cd-ship-free">FREE</b></span>'
      + (hasSave ? '<span class="cd-chip">You save ' + money(save) + '</span>' : '')
      + '</div>';
    var checkout = '<a href="/checkout" class="btn cd-checkout cd-checkout--orange">'
      + '<svg class="cd-lock" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>'
      + '<span class="cd-checkout-lbl">Checkout</span><span class="cd-checkout-amt">' + money(cart.total_price) + '</span><span class="arw">&rarr;</span></a>';
    elFoot.innerHTML = '<div class="cd-sum">' + totalRow + shipRow + '</div>' + checkout;
  }

  // cart-aware one-liner reused on product pages
  function onPageDeal(count, el) {
    if (count >= 3) return 'Your free tin and free shipping are locked in. Add more anytime.';
    if (count === 2) return 'Unlocked. Your 3rd tin is FREE. Pick any color and add it, it is on us.';
    if (count === 1) return 'Add 1 more to unlock your free tin. Your 3rd is on us.';
    // Empty cart: on a single product (PDP) show that product's own per-tin math,
    // read from data attributes so nothing is hardcoded. Elsewhere, stay generic.
    var unit = el && el.getAttribute('data-deal-unit');
    var three = el && el.getAttribute('data-deal-three');
    if (unit && three) {
      return 'Get your 3rd tin free. Buy 2, get 1 free, mix any colors or Editions. Three tins for ' + three + ', just ' + unit + ' each. Free shipping on every order.';
    }
    return 'Get your 3rd tin free. Buy 2, get 1 free, mix any colors or Editions. Free shipping on every order.';
  }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c); return c; });
  }
  function change(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function (c) { render(c); });
  }
  function addVariant(vid) {
    lastAddedId = Number(vid);
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(vid), quantity: 1 }) })
      .then(function () { return refresh(); }).then(scrollToAdded);
  }
  function scrollToAdded() {
    var el = drawer.querySelector('.cd-item--added');
    if (el && el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
  }

  // ---- Quick-edit popup: change an item's color or quantity in place ----
  var editEl = document.createElement('div');
  editEl.className = 'cd-edit';
  editEl.hidden = true;
  editEl.innerHTML =
    '<div class="cd-edit-panel">' +
      '<button type="button" class="cd-edit-x" data-cd-edit-cancel aria-label="Close">&times;</button>' +
      '<p class="cd-edit-title"></p>' +
        '<div class="cd-edit-prod" hidden><img class="cd-edit-prod-img" alt=""><span class="cd-edit-prod-name"></span></div>' +
        '<p class="cd-edit-lbl cd-edit-slots-lbl" hidden>Pick a color for each tin</p>' +
        '<div class="cd-edit-slots" hidden></div>' +
      '<div class="cd-edit-colorwrap">' +
        '<p class="cd-edit-lbl">Color: <strong class="cd-edit-color"></strong></p>' +
        '<div class="cd-sw-row cd-edit-swrow"></div>' +
      '</div>' +
      '<p class="cd-edit-lbl cd-edit-qlbl">Quantity</p>' +
      '<div class="cd-qty cd-edit-qty"><button type="button" data-cd-edit-dec aria-label="Decrease">&minus;</button><span class="cd-edit-qnum">1</span><button type="button" data-cd-edit-inc aria-label="Increase">+</button></div>' +
      '<button type="button" class="btn btn-brass cd-edit-update" data-cd-edit-update>Update</button>' +
    '</div>';
  drawer.appendChild(editEl);
  var editTitle = editEl.querySelector('.cd-edit-title');
  var editColorWrap = editEl.querySelector('.cd-edit-colorwrap');
  var editColorName = editEl.querySelector('.cd-edit-color');
  var editSwRow = editEl.querySelector('.cd-edit-swrow');
  var editQnum = editEl.querySelector('.cd-edit-qnum');
  var editSlots = editEl.querySelector('.cd-edit-slots');
  var editSlotsLbl = editEl.querySelector('.cd-edit-slots-lbl');
  var editQlbl = editEl.querySelector('.cd-edit-qlbl');
  var editQty = editEl.querySelector('.cd-edit-qty');
  var editUpdateBtn = editEl.querySelector('.cd-edit-update');
  var editProd = editEl.querySelector('.cd-edit-prod');
  var editProdImg = editEl.querySelector('.cd-edit-prod-img');
  var editProdName = editEl.querySelector('.cd-edit-prod-name');
  var editState = null;

  function productForItem(item) {
    for (var i = 0; i < cross.length; i++) { if (cross[i].id === item.product_id) return cross[i]; }
    return null;
  }
  function openEdit(key) {
    if (!currentCart) return;
    var item = null;
    for (var i = 0; i < currentCart.items.length; i++) { if (currentCart.items[i].key === key) { item = currentCart.items[i]; break; } }
    if (!item) return;
    // Per-tin colors for THIS line only, so the number of pickers matches the
    // quantity shown on the line (the Buy-2-Get-1 free tin is its own line).
    editState = { key: key, vid: item.variant_id, qty: item.quantity, productKeys: [key] };
    editUpdateBtn.textContent = 'Update';
    editUpdateBtn.classList.remove('cd-cta-orange');
    editProd.hidden = true;
    editSlotsLbl.textContent = 'Pick a color for each tin';
    editTitle.textContent = item.product_title;
    editQnum.textContent = item.quantity;
    var p = productForItem(item);
    var curV = p ? variantById(p, item.variant_id) : null, curPat = curV ? curV.pat : null, curColor = curV ? curV.title : null;
    var avail = p ? colorsOf(p, curPat) : [];
    editState.pat = curPat; editState.p = p;
    function swHTML(selVid) {
      return avail.map(function (v) {
        var url = SWATCH_IMG[v.title] || '';
        return '<button type="button" class="cd-sw' + ((v.id === selVid || v.title === curColor) ? ' is-sel' : '') + '" data-vid="' + v.id + '" data-name="' + v.title + '">' + (url ? '<img src="' + url + '" alt="' + v.title + '">' : '') + '</button>';
      }).join('') + (p && p.patterns ? patRow(p, curColor, curPat, 'data-edit-pat') : '');
    }
    var perTin = avail.length > 1 && item.quantity > 1;
    editState.perTin = perTin;
    if (perTin) {
      // one color picker per tin on this line
      var slotsHTML = '';
      for (var n = 1; n <= item.quantity; n++) {
        slotsHTML += '<div class="cd-edit-slot">' +
          '<p class="cd-edit-slbl">Tin ' + n + ': <strong class="cd-edit-sname">' + (item.variant_title || '') + '</strong></p>' +
          '<div class="cd-sw-row cd-edit-srow">' + swHTML(item.variant_id) + '</div>' +
        '</div>';
      }
      editSlots.innerHTML = slotsHTML;
      editSlots.hidden = false; editSlotsLbl.hidden = false;
      editColorWrap.hidden = true;
      editQlbl.hidden = true; editQty.hidden = true;
    } else if (avail.length > 1) {
      editSwRow.innerHTML = swHTML(item.variant_id);
      editColorName.textContent = curColor || (item.variant_title || '');
      editColorWrap.hidden = false;
      editSlots.hidden = true; editSlotsLbl.hidden = true;
      editQlbl.hidden = false; editQty.hidden = false;
    } else {
      editSwRow.innerHTML = '';
      editColorWrap.hidden = true;
      editSlots.hidden = true; editSlotsLbl.hidden = true;
      editQlbl.hidden = false; editQty.hidden = false;
    }
    editEl.hidden = false;
    requestAnimationFrame(function () { editEl.classList.add('is-open'); });
  }
  function closeEdit() {
    editEl.classList.remove('is-open');
    setTimeout(function () { editEl.hidden = true; }, 250);
    editState = null;
  }
  // ---- Build-your-3-pack, in the cart ----
  // Same builder as the product page: every tin still needed gets its own card where the shopper
  // can change the DESIGN and the COLOR. Tins already in the bag are listed above and left alone.
  // Nothing is added until they tap the button. The automatic Buy 2 Get 1 makes the cheapest free.
  var DESIGNS = [];
  try { DESIGNS = JSON.parse(document.getElementById('cd-designs').textContent); } catch (e) {}
  var GROUPS = [['course', 'The Course'], ['coast', 'The Coast'], ['country', 'The Country'], ['originals', 'The Originals'], ['more', 'More']];
  var bState = null;   // { have:[{title,sub,img,price}], picks:[{pid,vid,name,price}], open:{}, tab:{} }
  function designById(id) { for (var i = 0; i < DESIGNS.length; i++) if (String(DESIGNS[i].id) === String(id)) return DESIGNS[i]; return null; }
  function pickFor(d, vid, preferName, avoid) {
    var v = null, i;
    for (i = 0; i < d.variants.length; i++) if (String(d.variants[i].id) === String(vid) && d.variants[i].available) v = d.variants[i];
    if (!v && preferName) for (i = 0; i < d.variants.length; i++) if (d.variants[i].title === preferName && d.variants[i].available) v = d.variants[i];
    if (!v && avoid) for (i = 0; i < d.variants.length; i++) if (d.variants[i].available && !avoid[d.variants[i].id]) { v = d.variants[i]; break; }
    if (!v) for (i = 0; i < d.variants.length; i++) if (d.variants[i].available) { v = d.variants[i]; break; }
    return v ? { pid: d.id, vid: v.id, name: v.title, price: v.price, pat: v.pat || null } : null;
  }
  function pickCP(d, color, pat) { var v = variantFor(d, color, pat); return v ? { pid: d.id, vid: v.id, name: v.title, price: v.price, pat: v.pat || null } : null; }
  function pickLabel(p) { return p.name + (p.pat && p.pat !== 'Plain' ? ' \u00b7 ' + p.pat : ''); }
  function builderFree() {
    // cheapest of all three is free; if a new pick ties or wins, the badge goes on the LAST such pick
    // Oct 23 2026 (bug fix): crossed-out "was" sums each tin's compare-at (compareOf, same as the
    // cart) so the builder matches the cart totals instead of summing the plain price.
    var tins = bState.have.concat(bState.picks).map(function (t) {
      return { price: t.price, cmp: compareOf({ variant_id: t.vid, price: t.price }) || t.price };
    });
    var prices = tins.map(function (t) { return t.price; });
    var min = Math.min.apply(null, prices), total = prices.reduce(function (a, x) { return a + x; }, 0), freeIdx = -1;
    var was = tins.reduce(function (a, t) { return a + t.cmp; }, 0);
    bState.picks.forEach(function (p, i) { if (p.price <= min) freeIdx = i; });
    return { min: min, total: total, was: was, freeIdx: prices.length >= 3 ? freeIdx : -1, full: prices.length >= 3 };
  }
  function renderBuilder() {
    var f = builderFree(), html = '';
    if (bState.have.length) {
      html += '<ul class="cd-b-have">' + bState.have.map(function (h, i) {
        return '<li>' + (h.img ? '<img src="' + h.img + '" alt="">' : '') + '<span>Tin ' + (i + 1) + ': <b>' + escB(h.title) + '</b>' + (h.sub ? ' &middot; ' + escB(h.sub) : '') + '</span><span class="cd-b-in">In your bag</span></li>';
      }).join('') + '</ul>';
    }
    html += '<div class="cd-b-slots">' + bState.picks.map(function (p, i) {
      var d = designById(p.pid), free = i === f.freeIdx, open = !!bState.open[i];
      var sw = colorsOf(d, p.pat).map(function (v) {
        var url = SWATCH_IMG[v.title] || '';
        return '<button type="button" class="pdp-bundle-sw' + (v.title === p.name ? ' is-sel' : '') + '" data-vid="' + v.id + '" data-name="' + escB(v.title) + '" title="' + escB(v.title) + '"' + (v.available ? '' : ' disabled aria-disabled="true"') + '>' + (url ? '<img src="' + url + '" alt="' + escB(v.title) + '" loading="lazy">' : '') + '</button>';
      }).join('') + patRow(d, p.name, p.pat, 'data-b-pat');
      var picker = '';
      if (open) {
        var present = {}; DESIGNS.forEach(function (x) { present[x.g] = true; });
        var tab = bState.tab[i] || (present[d.g] ? d.g : 'all');
        bState.tab[i] = tab;
        var tabs = GROUPS.filter(function (g) { return present[g[0]]; });
        var list = DESIGNS.filter(function (x) { return tab === 'all' || x.g === tab; });
        picker = '<div class="pdp-bundle-dtabs">' + tabs.map(function (g) { return '<button type="button" class="pdp-bundle-dtab' + (g[0] === tab ? ' is-on' : '') + '" data-tab="' + g[0] + '">' + g[1] + '</button>'; }).join('') +
          '<button type="button" class="pdp-bundle-dtab' + (tab === 'all' ? ' is-on' : '') + '" data-tab="all">All</button></div>' +
          '<div class="pdp-bundle-dgrid">' + list.map(function (x) {
            return '<button type="button" class="pdp-bundle-design' + (String(x.id) === String(p.pid) ? ' is-sel' : '') + '" data-pid="' + x.id + '"><img src="' + (x.img || '') + '" alt="" loading="lazy">' + escB(x.title) + '</button>';
          }).join('') + '</div>';
      }
      return '<div class="pdp-bundle-slot' + (free ? ' is-free' : '') + '" data-bslot="' + i + '">' +
        '<div class="pdp-bundle-freebar"><span class="pdp-bundle-freetag">FREE</span><span class="pdp-bundle-freetxt">This one\'s on us</span><span class="pdp-bundle-freeprice"><s>' + money(compareOf({ variant_id: p.vid, price: p.price }) || p.price) + '</s> $0</span></div>' +
        '<div class="pdp-bundle-slot-row">' +
          '<button type="button" class="pdp-bundle-slot-img" data-b-design aria-label="Change design"><img src="' + (d.img || '') + '" alt="" loading="lazy"></button>' +
          '<div class="pdp-bundle-slot-main">' +
            '<div class="pdp-bundle-slot-top"><span class="pdp-bundle-slot-label">Tin ' + (bState.have.length + i + 1) + ' <span class="pdp-bundle-slot-design">' + escB(d.title) + '</span></span><span class="pdp-bundle-slot-price">' + (free ? 'FREE' : money(p.price)) + '</span></div>' +
            '<div class="pdp-bundle-slot-sub"><b class="pdp-bundle-slot-name">' + escB(pickLabel(p)) + '</b><button type="button" class="pdp-bundle-change" data-b-design>' + (open ? 'Close' : 'Change design') + '</button></div>' +
            '<div class="pdp-bundle-swrow">' + sw + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="pdp-bundle-designs"' + (open ? '' : ' hidden') + '>' + picker + '</div>' +
      '</div>';
    }).join('') + '</div>';
    if (f.full) {
      html += '<div class="pdp-bundle-pricerow cd-b-total"><div class="pdp-bundle-price"><span class="pdp-bundle-price-lbl">3 tins</span> <s class="pdp-bundle-price-was">' + money(f.was) + '</s> <span class="pdp-bundle-price-now">' + money(f.total - f.min) + '</span></div><span class="pdp-bundle-price-flag">You save ' + money(f.was - (f.total - f.min)) + '</span></div>';
      if (f.freeIdx === -1) html += '<p class="cd-b-note">Your free tin is the lowest priced of the three. It comes off automatically at checkout.</p>';
    }
    editSlots.innerHTML = html;
    var n = bState.picks.length;
    editUpdateBtn.textContent = (n === 1 && f.full) ? 'Add my free tin' : ('Add ' + n + (n === 1 ? ' tin' : ' tins') + ' to my bag');
  }
  function builderClick(t) {
    var slot = t.closest('[data-bslot]');
    if (!slot || !bState) return false;
    var i = Number(slot.getAttribute('data-bslot')), p = bState.picks[i], d = designById(p.pid);
    var sw = t.closest('.pdp-bundle-sw');
    if (sw) { if (!sw.disabled) { var np = pickCP(d, sw.getAttribute('data-name'), p.pat) || pickFor(d, sw.getAttribute('data-vid')); if (np) bState.picks[i] = np; renderBuilder(); } return true; }
    var bp = t.closest('[data-b-pat]');
    if (bp) { if (!bp.disabled) { var pp = pickCP(d, p.name, bp.getAttribute('data-b-pat')); if (pp) bState.picks[i] = pp; renderBuilder(); } return true; }
    if (t.closest('[data-b-design]')) { bState.open[i] = !bState.open[i]; renderBuilder(); return true; }
    var tab = t.closest('.pdp-bundle-dtab');
    if (tab) { bState.tab[i] = tab.getAttribute('data-tab'); renderBuilder(); return true; }
    var dz = t.closest('.pdp-bundle-design');
    if (dz) {
      var nd = designById(dz.getAttribute('data-pid'));
      // keep the same color when the new design has it
      var keep = nd ? pickFor(nd, null, p.name) : null;
      if (keep) bState.picks[i] = keep;
      bState.open[i] = false; bState.tab[i] = null;
      renderBuilder(); return true;
    }
    return true;
  }
  function openComplete() {
    if (!currentCart) return;
    var base = baseProductFromCart(currentCart);
    if (!base) { var st = studioFromCart(currentCart); if (st && currentCart.item_count < 3) window.location.href = st.url; return; }
    var need = 3 - currentCart.item_count;
    if (need <= 0) return;
    var startDesign = designById(base.p.id) || DESIGNS[0];
    if (!startDesign) return;
    var have = [];
    currentCart.items.forEach(function (it) {
      var pr = it.properties || {};
      for (var q = 0; q < it.quantity; q++) have.push({ title: it.product_title, sub: pr.Text ? ('"' + String(pr.Text).replace(/\n/g, ' / ') + '"') : ((it.variant_title && !/default/i.test(it.variant_title)) ? it.variant_title : ''), img: pr._Preview || it.image || '', price: it.price, vid: it.variant_id });
    });
    var used = usedVariants(currentCart, startDesign.id), picks = [];
    var baseIt = currentCart.items.filter(function (it) { return it.product_id === startDesign.id; })[0];
    var baseV = baseIt ? variantById(startDesign, baseIt.variant_id) : null, basePat = baseV ? baseV.pat : null;
    for (var k = 0; k < need; k++) {
      var pk = pickFor(startDesign, null, null, used);
      if (!pk) return;
      if (startDesign.patterns && basePat) { var pkp = pickCP(startDesign, pk.name, basePat); if (pkp && !used[pkp.vid]) pk = pkp; }   // same lid pattern as the tin in the bag
      used[pk.vid] = true; picks.push(pk);
    }
    bState = { have: have, picks: picks, open: {}, tab: {} };
    editState = { complete: true, need: need, pid: startDesign.id };
    editTitle.textContent = 'Build your 3-pack, 3rd tin free';
    editProd.hidden = true;
    editSlotsLbl.textContent = need === 1 ? 'Pick the design and color for your free tin' : 'Pick a design and color for each tin';
    renderBuilder();
    editSlots.hidden = false; editSlotsLbl.hidden = false;
    editColorWrap.hidden = true;
    editQlbl.hidden = true; editQty.hidden = true;
    editUpdateBtn.classList.add('cd-cta-orange');
    editEl.hidden = false;
    requestAnimationFrame(function () { editEl.classList.add('is-open'); });
  }
  function rowVariant(row, fallbackVid) {
    var s = row.querySelector('.cd-sw.is-sel'), c = row.querySelector('.pdp-bundle-pat.is-sel'), p = editState && editState.p;
    if (p && p.patterns && s) { var v = variantFor(p, s.getAttribute('data-name'), c ? c.getAttribute('data-edit-pat') : editState.pat); if (v) return Number(v.id); }
    return s ? Number(s.getAttribute('data-vid')) : fallbackVid;
  }
  function applyEdit() {
    if (!editState) return;
    if (editState.complete) {
      // Add each tin picked in the builder (any design, any color); the automatic Buy-2-Get-1 makes the cheapest free.
      var cpicks = bState ? bState.picks.map(function (p) { return Number(p.vid); }) : [];
      bState = null;
      if (!cpicks.length) { closeEdit(); return; }
      var ccounts = {};
      cpicks.forEach(function (v) { ccounts[v] = (ccounts[v] || 0) + 1; });
      var cAdd = Object.keys(ccounts).map(function (v) { return { id: Number(v), quantity: ccounts[v] }; });
      lastAddedId = cpicks[0];
      closeEdit();
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: cAdd }) })
        .then(function () { return refresh(); });
      return;
    }
    if (editState.perTin) {
      // gather each tin's chosen colorway, group identical ones, then rebuild the line(s)
      var picks = [];
      Array.prototype.forEach.call(editSlots.querySelectorAll('.cd-edit-slot'), function (slot) {
        picks.push(rowVariant(slot, editState.vid));
      });
      var counts = {};
      picks.forEach(function (v) { counts[v] = (counts[v] || 0) + 1; });
      var addItems = Object.keys(counts).map(function (v) { return { id: Number(v), quantity: counts[v] }; });
      lastAddedId = picks[0];
      var updates = {};
      (editState.productKeys || [editState.key]).forEach(function (k) { updates[k] = 0; });
      closeEdit();
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: addItems }) }); })
        .then(function () { return refresh(); });
      return;
    }
    var newVid = rowVariant(editSwRow, editState.vid);
    var newQty = Math.max(1, parseInt(editQnum.textContent, 10) || 1);
    var key = editState.key;
    var oldVid = editState.vid;
    closeEdit();
    if (newVid === oldVid) {
      change(key, newQty);
      return;
    }
    // color changed: drop the old line, add the chosen colorway at the same qty
    lastAddedId = newVid;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) })
      .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: newVid, quantity: newQty }) }); })
      .then(function () { return refresh(); });
  }

  // delegated events in the drawer
  drawer.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cd-close]')) { closeDrawer(); return; }
    // "Build your set" popup: from the CTA, or from the footer "Pick your FREE 3rd tin".
    if (t.closest('[data-cd-complete]')) { openComplete(); return; }
    if (t.closest('[data-cd-pick]')) {
      if (currentCart && baseProductFromCart(currentCart) && (3 - currentCart.item_count) > 0) { openComplete(); return; }
      var stp = currentCart ? studioFromCart(currentCart) : null;
      if (stp) { window.location.href = stp.url; return; }
      window.location.href = '/collections/all';
      return;
    }
    // 3-pack builder cards (change design / color) inside the pop-up
    if (bState && t.closest('[data-bslot]')) { builderClick(t); return; }
    // quick-edit popup controls
    if (t.closest('[data-cd-edit-cancel]')) { closeEdit(); return; }
    if (editEl.contains(t) && t === editEl) { closeEdit(); return; } // click on backdrop
    if (t.closest('[data-cd-edit-inc]')) { editQnum.textContent = (parseInt(editQnum.textContent, 10) || 1) + 1; return; }
    if (t.closest('[data-cd-edit-dec]')) { editQnum.textContent = Math.max(1, (parseInt(editQnum.textContent, 10) || 1) - 1); return; }
    if (t.closest('[data-cd-edit-update]')) { applyEdit(); return; }
    // pick a colorway swatch on a cross-sell card OR in the edit popup
    var pc = t.closest('[data-edit-pat]');
    if (pc && !pc.disabled) { var prow = pc.closest('.pdp-bundle-patrow'); Array.prototype.forEach.call(prow.querySelectorAll('.pdp-bundle-pat'), function (b) { b.classList.toggle('is-sel', b === pc); }); if (editState) editState.pat = pc.getAttribute('data-edit-pat'); return; }
    var sw = t.closest('.cd-sw');
    if (sw) {
      var row = sw.closest('.cd-sw-row');
      Array.prototype.forEach.call(row.querySelectorAll('.cd-sw'), function (b) { b.classList.remove('is-sel'); });
      sw.classList.add('is-sel');
      var info = sw.closest('.cd-x-info');
      var pick = info ? info.querySelector('.cd-x-picked strong') : null;
      if (pick) pick.textContent = sw.getAttribute('data-name');
      if (editColorName && sw.closest('.cd-edit')) editColorName.textContent = sw.getAttribute('data-name');
      var eslot = sw.closest('.cd-edit-slot');
      if (eslot) { var sn = eslot.querySelector('.cd-edit-sname'); if (sn) sn.textContent = sw.getAttribute('data-name'); }
      return;
    }
    var itemEl = t.closest('.cd-item[data-key]');
    if (itemEl) {
      var key = itemEl.getAttribute('data-key');
      if (t.closest('[data-cd-edit]')) { openEdit(key); return; }
      if (t.closest('[data-cd-remove]')) { change(key, 0); return; }
      var qEl = itemEl.querySelector('.cd-qty span');
      if (qEl) {
        var q = parseInt(qEl.textContent, 10);
        if (t.closest('[data-cd-inc]')) { change(key, q + 1); return; }
        if (t.closest('[data-cd-dec]')) { change(key, Math.max(0, q - 1)); return; }
      }
    }
    var addBtn = t.closest('[data-cd-add]');
    if (addBtn) {
      var card = addBtn.closest('.cd-x-card');
      var chosen = card ? card.querySelector('.cd-sw.is-sel') : null;
      var vid = chosen ? chosen.getAttribute('data-vid') : addBtn.getAttribute('data-vid');
      addBtn.disabled = true; addBtn.textContent = 'Added';
      addVariant(vid);
      return;
    }
  });
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeDrawer(); });

  // cart icon opens the drawer instead of navigating
  Array.prototype.forEach.call(document.querySelectorAll('.js-cart-toggle'), function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); refresh(); });
  });

  // intercept every add-to-cart on the site -> AJAX add -> open the drawer
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var action = form && form.getAttribute ? (form.getAttribute('action') || '') : '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var fd = new FormData(form);
    var addedId = fd.get('id'); if (addedId) lastAddedId = Number(addedId);
    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function () { return refresh(); })
      .then(function () { openDrawer(); scrollToAdded(); })
      .catch(function () { form.submit(); });
  });

  refresh().then(function (c) {
    // Someone who lands on /cart (back button, Shop app, no-JS link) gets the drawer right away.
    if (c && c.item_count > 0 && /^\/cart\/?$/.test(location.pathname)) openDrawer();
  });   // populate on load (count badge, on-page deal line)
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

/* ============================================================
   COLLECTION / CARD colorway picker (add-to-cart happens via the
   global submit interceptor above, which opens the drawer)
   ============================================================ */
(function () {
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.ec-sw');
    if (!sw) return;
    var form = sw.closest('.ec-add');
    if (!form) return;
    Array.prototype.forEach.call(form.querySelectorAll('.ec-sw'), function (b) { b.classList.remove('is-sel'); });
    sw.classList.add('is-sel');
    var idInput = form.querySelector('.ec-id');
    if (idInput) idInput.value = sw.getAttribute('data-vid');
    var name = form.querySelector('.ec-picked-name');
    if (name) name.textContent = sw.getAttribute('data-name');
    // Swap the card's main photo to this colorway's own photo, when one exists.
    // Products without per-color photos have no data-img, so the photo just stays put.
    // Direct src swap: the browser keeps showing the old photo until the new one loads,
    // so there is no blank flash and nothing can get stuck hidden.
    var newImg = sw.getAttribute('data-img');
    var card = sw.closest('.edition-card');
    if (card && newImg) {
      var mainImg = card.querySelector('.edition-img img');
      if (mainImg && mainImg.getAttribute('src') !== newImg) { mainImg.src = newImg; }
    }
  });
})();
